import { FormGroup, Input, Label } from "reactstrap";
import { AdditionalFieldSelectPreview } from "./AdditionalFieldSelectPreview";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { additionalFieldTypes } from "./additionalFieldTypes";

export function AdditionalFieldPreview({ name, required, type, configuration, placeholder: helperText }) {
  const { t } = useTranslation()

  const placeholder = useMemo(() => {
    const text = additionalFieldTypes.find((field) => field.type === type).placeholder

    if (!text) return undefined

    return t(text)
  }, [type, t])

  return (
    <FormGroup className="mt-3">
      <Label id="additionalfield-type-label">
        {name + (required ? " *" : "")}
      </Label>
      {type === "select" && (
        <AdditionalFieldSelectPreview configuration={configuration} />
      )}
      {type !== "select" && (
        <Input type="text" placeholder={placeholder} disabled />
      )}
      {helperText && (
        <small>{helperText}</small>
      )}
    </FormGroup>
  )
}
